module.exports = __webpack_public_path__ + "static/media/giftbox.7424f1ac.svg";


//////////////////
// WEBPACK FOOTER
// ./src/web/pages/promocoes/giftbox.svg
// module id = 1054
// module chunks = 0